<ng-container>
  @if (sent()) {
    <alert [type]="'success'" [removeAble]="false">
      {{ 'Contact message sent' | trans }}
    </alert>
  } @else {
    <form-group
      [name]="name()"
      [type]="formType"
      [data]="localData()"
      [(error)]="error"
      (onSubmit)="onSubmit($event)"
    >
      <div [contentFlex]="'content'" [row]="'computer'">
        <div [contentFlex]="'content'" [col]="'12|6-computer'">
          <form-row [target]="'fullName'"/>
        </div>

        <div [contentFlex]="'content'" [col]="'12|6-computer'">
          <form-row [target]="'email'"/>
        </div>
      </div>

      <form-row [target]="'subject'"/>

      <form-row [target]="'message'"/>

      <form-footer>
        <form-button [label]="'Send message'"/>
      </form-footer>
    </form-group>
  }
</ng-container>
